// extracted by mini-css-extract-plugin
export var compact = "_mp-2";
export var phoneFrame = "_mp-0";
export var phoneScreen = "_mp-1";